const logosBase = '/images/logos'
const LOGOS: Record<string, string> = {
  gearsOfWar: `${logosBase}/gearsOfWar-white.svg`,
  gearsOfWarFull: `${logosBase}/gearsOfWar-full-white.svg`,
  gearsOfWarNoOmen: `${logosBase}/gearsOfWar-vertical-no-omen-white.svg`,
  theCoalition: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/theCoalition-white-5f2b1be4bddeb-6705aa9b6d1ed.svg',
  theCoalitionFull: `${logosBase}/theCoalition-full-white.svg`,
  xboxGameStudios: 'https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/10/XboxGameStudios_2020_hrz_Wht-5f2b1addc7aa9-6705aa94c2dff.svg',
  xboxLive: `${logosBase}/xboxLive-white.svg`,
  matureContent: `https://dev.cdn.gearsofwar.com/gearsofwar/sites/3/2026/02/esrb-m-content-699764e407881.svg`
}

const useLogo = (name: string = 'gearsOfWarFull') => LOGOS[name]

export default useLogo
